import { useGetParams } from '../../hooks/useGetParams';
import styles from './SmallAdvt.module.css';

import logo from '../../assets/images/logo.png';

export const SmallAdvt = () => {
  const { qrCode1, qrCode2, title } = useGetParams();

  const sizeQR = '22.9';
  return (
    <div className={styles.wrapperSmallAdvt}>
      <img src={logo} alt="logo" className={styles.logo} />

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <div
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </div>
        )}
        {qrCode2 && (
          <div
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode2" />
          </div>
        )}
      </div>

      {title && (
        <div className={styles.titleBlock}>
          <div className={styles.alhimiya}>{title}</div>
          <div className={styles.leftTop} />
          <div className={styles.rightTop} />
          <div className={styles.rightBottom} />
          <div className={styles.leftBottom} />
        </div>
      )}
    </div>
  );
};
